import { useEffect } from "react";
import { MapContainer, TileLayer, CircleMarker, Tooltip, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { LIGHT, kw, DIREZ } from "./shared";

const Fit = ({ pts }) => {
  const map = useMap();
  const sig = pts.map((p) => p.id).join(",");
  useEffect(() => {
    if (pts.length === 1) map.setView([pts[0].lat, pts[0].lng], 11);
    else if (pts.length > 1) map.fitBounds(pts.map((p) => [p.lat, p.lng]), { padding: [30, 30], maxZoom: 12 });
  }, [sig]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
};

export function MonitoringMap({ plants, onSelect }) {
  const pts = plants.filter((p) => p.lat != null && p.lng != null);
  return (
    <div className="relative isolate h-[320px] overflow-hidden rounded-2xl border border-neutral-800 sm:h-[420px]" data-testid="monitoring-map">
      <style>{`.mon-dark-tiles{filter:invert(1) hue-rotate(180deg) brightness(.85) contrast(.9) saturate(.4)}`}</style>
      <MapContainer center={[44.5, 11]} zoom={6} scrollWheelZoom={false} className="h-full w-full" style={{ background: "#0b0b0b" }}>
        <TileLayer attribution="&copy; OpenStreetMap" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" className="mon-dark-tiles" />
        <Fit pts={pts} />
        {pts.map((p) => (
          <CircleMarker key={p.id} center={[p.lat, p.lng]} radius={p.light === 1 ? 7 : 9}
            eventHandlers={{ click: () => onSelect(p.id) }}
            pathOptions={{ color: LIGHT[p.light].color, fillColor: LIGHT[p.light].color, fillOpacity: 0.85, weight: p.light === 1 ? 1 : 3 }}>
            <Tooltip direction="top">
              <div className="text-[12px]"><b>{p.nome}</b> · {p.comune}{p.partner_id === DIREZ && " · Direzionale"}<br />{LIGHT[p.light].label} · {kw(p.pac_w)}</div>
            </Tooltip>
          </CircleMarker>
        ))}
      </MapContainer>
      {!!pts.length && <div className="pointer-events-none absolute bottom-1 left-2 z-[500] rounded bg-black/60 px-2 py-0.5 text-[10px] text-neutral-400" data-testid="monitoring-map-note">Posizioni indicative nella zona del Partner (FIER non fornisce l'indirizzo)</div>}
      {!pts.length && <div className="pointer-events-none absolute inset-0 z-[500] flex items-center justify-center bg-black/40 text-sm text-neutral-300" data-testid="monitoring-map-empty">{plants.length && plants.every((p) => p.partner_id === DIREZ) ? "Impianti direzionali senza posizione: inserisci l'indirizzo nella scheda impianto" : "Nessun impianto abbinato a un Partner con posizione"}</div>}
    </div>
  );
}
